export default {

  //系统基础
  PERMISSION_ORGAN_INDEX:'1100',//机构管理
  PERMISSION_USER_INDEX:'1200',//用户管理
  PERMISSION_USER_ADD:'1201',//用户管理-新增
  PERMISSION_PERMISSION_INDEX :'1300',//权限管理
  PERMISSION_ROLE_INDEX :'1400',//角色管理
  PERMISSION_BANNER_INDEX:'1500',//轮播图管理

  //业务部分
  PERMISSION_CUSTOMER_INDEX :'2100',//客户管理
  PERMISSION_CAR_INDEX :'2300',//车辆管理
  //PERMISSION_BUS_ORDER_INDEX :'2310',//业务管理员订单管理
  PERMISSION_BUSINESS_ORDER_INDEX :'2310',//业务管理员订单管理
  PERMISSION_CAR_ORDER_INDEX :'2320',//订单车辆信息管理
  PERMISSION_USER_ORDER_INDEX :'2330',//订单用户信息管理
  PERMISSION_LOAN_ORDER_INDEX :'2340',//订单贷款信息管理
  PERMISSION_CAR_DETAIL_INDEX :'2350',//车辆详情信息
  PERMISSION_CAR_EVALUATION_INDEX :'2360',//车辆评估

  PERMISSION_SHOP_INDEX :'2400',//门店仓库管理
  PERMISSION_FUNDS_INDEX :'2500',//资金管理
  PERMISSION_FUNDS_DETAIL_INDEX :'2501',//资金管理详情
  PERMISSION_RISK_ORDER_INDEX :'2600',//风险评估员订单信息管理
  PERMISSION_RISK_DETAIL_INDEX :'2601',//风险订单详情信息管理
  PERMISSION_BROKERAGE_INDEX :'2700',//佣金管理
  PERMISSION_OVERDUE_INDEX :'2710',//逾期管理
  PERMISSION_PRICING_INDEX :'2800',//定价管理
  PERMISSION_PRICING_DETAIL_INDEX :'2801',//定价管理详情
  PERMISSION_EXTRACTCARAPP_INDEX:'3100',//提车申请
  PERMISSION_LOAN_APP_INDEX:'3200',//贷款申请
}












// WEBPACK FOOTER //
// ./src/constant/PermissionIds.js